import { z } from 'zod';
/**
 * Hợp đồng API của module `staff` — việc Trưởng phòng làm được TRONG PHÒNG MÌNH (Giám đốc cũng gọi
 * được): xếp lại nhóm, duyệt / từ chối đơn đăng ký.
 */
export const staffParamsSchema = z.object({ username: z.string().max(64) });
export const moveStaffRequestSchema = z.object({
    /** Nhóm đích. Chuỗi rỗng = đưa người đó ra khỏi mọi nhóm (vẫn ở nguyên phòng). */
    teamId: z.string().max(64).default(''),
});
/**
 * Trưởng phòng duyệt đơn vào PHÒNG MÌNH: phòng là phòng của người duyệt, chỉ chọn chức vụ (Trưởng nhóm /
 * Nhân viên — xem `HEAD_ASSIGNABLE_ROLES`) và nhóm. Schema lỏng như `users.ts`: sai gì service báo bằng
 * câu tiếng Việt.
 */
export const approveStaffRequestSchema = z.object({
    role: z.string().max(32).default(''),
    /**
     * Phòng nhận người (thêm 29/09/2026): Trưởng phòng KIÊM NHIỆM nhiều phòng chọn đưa người vào phòng nào
     * trong số phòng mình đứng đầu; chuỗi rỗng = phòng chính của người duyệt. Phòng khác thì bị từ chối.
     */
    departmentId: z.string().max(64).default(''),
    /** Nhóm trong phòng; chuỗi rỗng = chưa xếp nhóm (Trưởng nhóm thì bắt buộc có). */
    teamId: z.string().max(64).default(''),
});
//# sourceMappingURL=staff.js.map